export const supportedLocales = [
  'de-AT',
  'de-DE',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-HK',
  'en-IN',
  'en-NZ',
  'en-SG',
  'en-TH',
  'en-US',
  'en-XB',
  'es-AR',
  'es-ES',
  'es-MX',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'it-IT',
  'ja-JP',
  'nl-BE',
  'nl-NL',
  'sv-SE',
  'zh-HK',
  'zh-TW',
] as const;

export const locales = {
  Argentina: 'es-AR',
  Canada: 'fr-CA',
  France: 'fr-FR',
  Germany: 'de-DE',
  Italy: 'it-IT',
  Mexico: 'es-MX',
  Spain: 'es-ES',
  Switzerland: 'en-CH',
  UnitedStates: 'en-US',
};

const tempClosedTranslations = {
  es: 'cerrado temporalmente',
  fr: 'temporairement fermé',
  de: 'vorübergehend geschlossen',
  it: 'temporaneamente chiusa',
};

export const langs = {
  EN: 'EN',
  ES: 'ES',
};

export const supportedMarkets = [
  {
    name: 'Argentina',
    locale: 'es-ar',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Australia',
    locale: 'en-au',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Austria',
    locale: 'de-at',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Belgium',
    locale: 'nl-be',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Canada',
    locale: 'fr-ca',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Canada',
    locale: 'en-ca',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Finland',
    locale: 'fi-fi',
    products: [{ name: 'the-platinum-card', showInCardPicker: true }],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'France',
    locale: 'fr-fr',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Germany',
    locale: 'de-de',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Hong Kong SAR',
    locale: 'en-hk',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'Hong Kong SAR',
    locale: 'zh-hk',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'India',
    locale: 'en-in',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'International Currency Card',
    locale: 'en-xb',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Italy',
    locale: 'it-it',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Japan',
    locale: 'ja-jp',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Mexico',
    locale: 'es-mx',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'The Netherlands',
    locale: 'nl-nl',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'New Zealand',
    locale: 'en-nz',
    products: [{ name: 'the-platinum-card', showInCardPicker: true }],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Singapore',
    locale: 'en-sg',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Spain',
    locale: 'es-es',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Sweden',
    locale: 'sv-se',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'Taiwan',
    locale: 'zh-tw',
    products: [
      { name: 'the-platinum-card', showInCardPicker: false },
      { name: 'the-centurion-card', showInCardPicker: false },
    ],
    showInCardPicker: false,
    multiLanguage: false,
  },
  {
    name: 'Thailand',
    locale: 'en-th',
    products: [{ name: 'the-platinum-card', showInCardPicker: true }],
    showInCardPicker: true,
    multiLanguage: true,
  },
  {
    name: 'United Kingdom',
    code: 'UK',
    locale: 'en-gb',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
  {
    name: 'United States',
    code: 'US',
    locale: 'en-us',
    products: [
      { name: 'the-platinum-card', showInCardPicker: true },
      { name: 'the-platinum-card-idc-en', showInCardPicker: true },
      { name: 'delta-reserve', showInCardPicker: true },
      { name: 'the-centurion-card', showInCardPicker: true },
      { name: 'the-centurion-card-idc-en', showInCardPicker: false },
    ],
    showInCardPicker: true,
    multiLanguage: false,
  },
];

export const localesWithTempClosedTranslation = {
  [locales.Argentina]: tempClosedTranslations.es,
  [locales.Spain]: tempClosedTranslations.es,
  [locales.Mexico]: tempClosedTranslations.es,
  [locales.Canada]: tempClosedTranslations.fr,
  [locales.France]: tempClosedTranslations.fr,
  [locales.Germany]: tempClosedTranslations.de,
  [locales.Italy]: tempClosedTranslations.it,
};
